
import axios from "axios";
import { LayoutResponse, StateResponse } from "./types";

const request = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '',
});


export const getLayout = async (wlp: string): Promise<LayoutResponse[]> => {

    const response = await request.get(`/api-openid/landing/status/${wlp}`);
    return response?.data || [];

};


export const checkState = async (state: string): Promise<StateResponse> => {
    const response = await request.get(`/api-openid/landing/check/${state}`);
    return response?.data;
};